import type { ProfessorImpactFormValues } from "./types";

export const REFERRAL_SOURCE_OTHER_VALUE = "Other";

export const referralSourceOptions = [
  { translationKey: "fieldOptions.referral_source.elevenlabs_website" as const, value: "ElevenLabs website" },
  { translationKey: "fieldOptions.referral_source.professor_colleagues" as const, value: "Professor colleagues" },
  { translationKey: "fieldOptions.referral_source.students" as const, value: "Students" },
  { translationKey: "fieldOptions.referral_source.social_media" as const, value: "Social media" },
  { translationKey: "fieldOptions.referral_source.other" as const, value: REFERRAL_SOURCE_OTHER_VALUE },
];

export const PROFESSOR_IMPACT_FORM_DEFAULTS: ProfessorImpactFormValues = {
  firstName: "",
  lastName: "",
  email: "",
  institution: "",
  website: "",
  useCase: "",
  studentAccess: "",
  referralSource: "",
  referralSourceOther: "",
  featuredConsent: false,
  termsAgreed: false,
};

export const fieldConfig = {
  firstName: {
    name: "firstName" as const,
    required: true,
  },
  lastName: {
    name: "lastName" as const,
    required: true,
  },
  email: {
    name: "email" as const,
    required: true,
  },
  institution: {
    name: "institution" as const,
    required: true,
  },
  website: {
    name: "website" as const,
    required: true,
  },
  useCase: {
    name: "useCase" as const,
    required: true,
  },
  studentAccess: {
    name: "studentAccess" as const,
    required: true,
  },
  referralSource: {
    name: "referralSource" as const,
    required: true,
  },
  referralSourceOther: {
    name: "referralSourceOther" as const,
    required: true,
  },
  featuredConsent: {
    name: "featuredConsent" as const,
    required: false,
  },
  termsAgreed: {
    name: "termsAgreed" as const,
    required: true,
  },
};
